import type { UniqAppConfig } from '../UniqAppConfig.types';
import { useKorintConfig } from './useKorintConfig';

export function useKorintUniqConfig() {
  const { korintConfig } = useKorintConfig();

  if (!korintConfig.uniqAppConfig) {
    throw new Error('[{UniqApp}] Korint uniq app config not found');
  }

  return korintConfig.uniqAppConfig as NonNullable<UniqAppConfig>;
}
